// eslint-disable-next-line import/prefer-default-export
export const QualificationFilterValues = Object.freeze({ All: false, Qualified: true})
